var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#B4B8CF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.19991H16V4.79991H14.4V15.1999C14.4 15.4121 14.3157 15.6156 14.1657 15.7656C14.0157 15.9156 13.8122 15.9999 13.6 15.9999H2.4C2.18783 15.9999 1.98434 15.9156 1.83431 15.7656C1.68429 15.6156 1.6 15.4121 1.6 15.1999V4.79991H0V3.19991H4V0.799908C4 0.587735 4.08429 0.384252 4.23431 0.234223C4.38434 0.0841939 4.58783 -9.15527e-05 4.8 -9.15527e-05H11.2C11.4122 -9.15527e-05 11.6157 0.0841939 11.7657 0.234223C11.9157 0.384252 12 0.587735 12 0.799908V3.19991ZM12.8 4.79991H3.2V14.3999H12.8V4.79991ZM5.6 7.19991H7.2V11.9999H5.6V7.19991ZM8.8 7.19991H10.4V11.9999H8.8V7.19991ZM5.6 1.59991V3.19991H10.4V1.59991H5.6Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.032eee0c54300e688e69f1f214faa11b.svg";
export { ForwardRef as ReactComponent };